import styled, { css } from "styled-components";
import {Text1, Title1} from "../../../../styles/business-components";

import SliderItemLeftLines from '../../../../assets/images/business/b_m_cnt7_left_lines.svg'
import SliderItemRightLines from '../../../../assets/images/business/b_m_cnt7_right_lines.svg'

export const Title = styled(Title1)`
  text-align: left;
  
  @media only screen and (${({theme}) => theme.media.large}) {
    text-align: center;
  }
`

export const Text = styled(Text1)`
  line-height: 30px;
  
  @media only screen and (${({theme}) => theme.media.large}) {
    line-height: 17px;
  }
`

export const SliderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  margin-top: 20px;

  @media only screen and (${({theme}) => theme.media.large}) {
    margin-top: 100px;
  }
`

export const SliderMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const SliderMenuItem = styled.div<{active?: boolean}>`
  padding: 20px 10px;
  border-radius: 40px;
  border: 1px solid;
  opacity: 0.5;
  color: ${({theme}) => theme.business.colors.textColor};
  font-size: 18px;
  line-height: 30px;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  ${({active, theme}) => active 
          ? 
          css`
            opacity: 1;
            border-color: ${theme.business.colors.primary};
            color: ${theme.business.colors.primary};
            background: ${theme.business.colors.sliderBackground};
          `
          :
          css`
            opacity: 0.5;
            border-color: ${theme.business.colors.sliderBorderColor};
            color: ${theme.business.colors.textColor}
          `
  };

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 20px;
    line-height: 26px;
  }
`

export const Slider = styled.div`
  width: 100vw;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transform-style: preserve-3d;
  perspective: 600px;
  //pointer-events: none;

  @media only screen and (${({theme}) => theme.media.large}) {
    height: 500px;
  }
`
function positioning(position, rowNumber, offset) {
  const blur = position !== rowNumber ? '2px' : '0';
  const opacity = position !== rowNumber ? 0.5 : 1;
  const scale = position !== rowNumber ? '0.8' : '1';
  const visibility = Math.abs(rowNumber - position) > 1 ? 'hidden' : 'visible';
  const translateX = position === rowNumber ? 0 : position > rowNumber ? `-${offset}px` : `${offset}px`
  const r = position - rowNumber;
  const abs = Math.max(r * -1, r);
  return css`
    opacity: ${opacity};
    scale: ${scale};
    visibility: ${visibility};
    transform: translateX(${translateX});
    z-index: calc((${position} - ${abs}))
  `;
}

export const SliderItem = styled.div<{position?: number, rowNumber?: number, image}>`
  ${({image}) => css`background: url("${image}") no-repeat`};
  background-size: cover;
  position: absolute;
  border-radius: 20px;
  width: 320px;
  height: 220px;
  ${({position = 0, rowNumber = 0}) => positioning(position, rowNumber, 60)};

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    width: 550px;
    height: 350px;
    ${({position = 0, rowNumber = 0}) => positioning(position, rowNumber, 180)};
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    width: 900px;
    height: 500px;
    ${({position = 0, rowNumber = 0}) => positioning(position, rowNumber, 280)};
  }

  transition: all 0.25s linear;

  &::before {
    display: block;
    content: " ";
    border-radius: 20px;
    background-image: url('${SliderItemLeftLines}');
    background-repeat: no-repeat;
    background-size: contain;
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  &::after {
    display: block;
    content: " ";
    border-radius: 20px;
    background-image: url('${SliderItemRightLines}');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right;
    height: 50%;
    width: 100%;
    position: absolute;
    right: 0;
    bottom: 0;
  }
`

export const SliderContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 55%;
  height: 100%;
  padding: 10% 0 15px 30px;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    width: 35%;
  }
`

export const SliderItemTitle = styled.div`
  font-size: 14px;
  line-height: 40px;
  font-weight: 600;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 10px;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 18px;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 30px;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 24px;
    line-height: 60px;
  }
`

export const SliderItemText = styled.div`
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0.015em;
  color: rgba(255, 255, 255, 1);

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 16px;
    line-height: 30px;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 20px;
    line-height: 30px;
  }
`

export const SliderItemLogo = styled.div`
  margin-top: auto;
  & svg {
    width: 100px;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    & svg {
      width: 152px;
    }
  }
`